import * as React from 'react';
import styled from 'styled-components';

const SVG = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props}  xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
    <rect x="30.0898" width="29.61" height="29.61" rx="14.805" transform="rotate(90 30.0898 0)" fill="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M13.4346 10.1785C13.4346 9.66745 13.0203 9.25317 12.5093 9.25317C11.9983 9.25317 11.584 9.66745 11.584 10.1785V19.4316C11.584 19.9426 11.9983 20.3569 12.5093 20.3569C13.0203 20.3569 13.4346 19.9426 13.4346 19.4316V10.1785ZM18.9865 10.1785C18.9865 9.66745 18.5722 9.25317 18.0612 9.25317C17.5501 9.25317 17.1359 9.66745 17.1359 10.1785V19.4316C17.1359 19.9426 17.5501 20.3569 18.0612 20.3569C18.5722 20.3569 18.9865 19.9426 18.9865 19.4316V10.1785Z" fill="#191A1F"/>
    </svg>
);

const Pause2: React.FC<React.SVGProps<SVGSVGElement>> = styled(SVG)`
  display: ${({ display = 'inline-block' }) => display};
  font-size: ${({ fontSize = '32px' }) => fontSize};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default Pause2;
